import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { useApp } from '../../context/AppContext';

const MainLayout = ({ children }) => {
    const { isUser } = useApp();

    return (
        <div className="flex min-h-screen bg-gray-50 md:pb-0 pb-6">
            {isUser && <Sidebar />}
            <div className={`flex-1 px-[2%] ${isUser ? 'lg:pl-[272px]' : ''}`}>
                <div className="md:p-4 pt-8 px-3 pb-3">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MainLayout;